
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iVane", function(module, exports) {
/* InlineCommentLinkHandler.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $1bY7o = parcelRequire("1bY7o");


var $aHcFH = parcelRequire("aHcFH");

const $2e6f10555c5fd465$var$hyperlinkPopupContainerStyle = null;
const $2e6f10555c5fd465$var$PANEL_LOOKUP_THROTTLE = 1000; // We need to truncate links that are longer than 20 characters so they fit in the line
const $2e6f10555c5fd465$var$truncateLink = (link)=>link.length > 19 ? `${link.substr(0, 20)}...` : link;
const $2e6f10555c5fd465$export$bc1299337a3f97b6 = /*#__PURE__*/ (0, $42omo.memo)(()=>{
    const [hasPanelLoaded, setHasPanelLoaded] = (0, $42omo.useState)(false);
    const contentBodyRef = (0, $42omo.useRef)(null);
    const hoveredAnchorRef = (0, $42omo.useRef)(null);
    const hideTimeoutRef = (0, $42omo.useRef)(null);
    const [popUpLink, setPopUpLink] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        // This tag is the same for both fabric and tiny pages
        contentBodyRef.current = document.querySelector('div#content[data-inline-comments-target="true"]');
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (contentBodyRef.current) {
            let throttledPanelLookupHandle = null; // Event handlers attaching hover behavior to links are happening _before_ Panel macro loads
            // Re-run `handleMouseEnter` after Panel element is loaded in the DOM
            const panelSelector = '.ak-editor-panel';
            const observer = new MutationObserver((mutationsList)=>{
                const hasChildListMutation = mutationsList.some((m)=>m.type === 'childList');
                if (hasChildListMutation && !throttledPanelLookupHandle) throttledPanelLookupHandle = window.setTimeout(()=>{
                    throttledPanelLookupHandle = null;
                    const element = document.querySelector(panelSelector);
                    if (element) {
                        observer.disconnect();
                        if (!hasPanelLoaded) setHasPanelLoaded(true); // Once one Panel macro has loaded, we know that the rest of the Panel macros on the page has loaded. There's no need to iterate through the rest
                    }
                }, $2e6f10555c5fd465$var$PANEL_LOOKUP_THROTTLE);
            });
            observer.observe(contentBodyRef.current, {
                childList: true,
                subtree: true
            });
            return ()=>{
                observer.disconnect();
                if (throttledPanelLookupHandle) window.clearTimeout(throttledPanelLookupHandle);
            };
        }
    }, [
        hasPanelLoaded
    ]);
    const handleMouseLeave = (0, $42omo.useCallback)((e)=>{
        const { target: target } = e;
        target.removeEventListener('mouseleave', handleMouseLeave);
        hideTimeoutRef.current = setTimeout(()=>{
            hoveredAnchorRef.current = null;
            setPopUpLink(null);
        }, 2000);
    }, [
        hideTimeoutRef,
        hoveredAnchorRef
    ]);
    const handleMouseEnter = (0, $42omo.useCallback)((e)=>{
        const { target: target } = e;
        let isOverHighlight = false;
        const highlightedComments = target.querySelectorAll('mark[data-mark-annotation-type="inlineComment"]');
        for (const element of highlightedComments)// Only add this handler to links WITH comments on them and ignore block level annotations
        if (element.classList.contains((0, $aHcFH.HIGHLIGHT_CLASS)) || element.getAttribute('data-mark-annotation-state') !== 'resolved' && element.getAttribute('data-block-mark') !== 'true') {
            isOverHighlight = true;
            break;
        }
        if (isOverHighlight) {
            const link = $2e6f10555c5fd465$var$truncateLink(target.getAttribute('href')); // Don't recalculate if we're showing the same pop-up
            if (link === popUpLink) return;
            if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
            target.setAttribute('style', 'position: relative');
            hoveredAnchorRef.current = target;
            target.addEventListener('mouseleave', handleMouseLeave);
            setPopUpLink(link);
        }
    }, [
        hideTimeoutRef,
        hoveredAnchorRef,
        popUpLink,
        handleMouseLeave
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!contentBodyRef.current) return;
         // Set up the event handler
        contentBodyRef.current?.querySelectorAll('a[href]').forEach((anchor)=>anchor.addEventListener('mouseenter', handleMouseEnter));
        return ()=>{
            // Remove the event listener
            contentBodyRef.current?.querySelectorAll('a[href]').forEach((anchor)=>anchor.removeEventListener('mouseenter', handleMouseEnter));
        };
    }, [
        hasPanelLoaded,
        contentBodyRef,
        handleMouseEnter
    ]);
    return popUpLink && hoveredAnchorRef.current ? /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_11q7vuon _2rko12b0 _1yt41bs6 _kqswstnw _154ir8pp _1ltvr8pp _1bsbuuw1 _16qst7xp _vchh1ntv _1luy1r31 _1ez1glyw _63ionqa1 _15dzazsu _1kal14y2 _11qwv77o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
        spacing: "spacious",
        label: "inline-comment-hyperlink-icon",
        color: "var(--ds-icon-accent-gray, #7D818A)"
    }), popUpLink), hoveredAnchorRef.current) : null;
});
module.exports["InlineCommentLinkHandler"] = $2e6f10555c5fd465$export$bc1299337a3f97b6;

});

parcelRegister("habRv", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $d7o2V = parcelRequire("d7o2V");


var $lspPP = parcelRequire("lspPP");

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");




function $1befae30f885f9b9$export$f9718e664221d42a({ render: render }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lspPP.RendererActionsContextConsumer), {
        children: (actions)=>render(actions)
    });
}



var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $7aRa9 = parcelRequire("7aRa9");


var $6UYek = parcelRequire("6UYek");





var $cZa7r = parcelRequire("cZa7r");


var $4gEXU = parcelRequire("4gEXU");

function $0779e224f4e996ea$export$6f846e47e87c2a09() {
    const { handleClose: handleClose } = (0, $cZa7r.useAnnotationsDispatch)();
    const onConfirm = (0, $42omo.useCallback)(()=>{
        handleClose();
    }, [
        handleClose
    ]);
    (0, $4gEXU.usePreemptiveGate)({
        onConfirm: onConfirm
    });
    return null;
}






var $kyKWe = parcelRequire("kyKWe");


var $21K7m = parcelRequire("21K7m");


var $gczDe = parcelRequire("gczDe");


var $brNvA = parcelRequire("brNvA");


var $3YBks = parcelRequire("3YBks");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");





var $gtD4K = parcelRequire("gtD4K");


var $T1bCI = parcelRequire("T1bCI");


var $4KS7f = parcelRequire("4KS7f");


var $1yB28 = parcelRequire("1yB28");


var $3gadb = parcelRequire("3gadb");





var $aWwYt = parcelRequire("aWwYt");





var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");





var $hrAmX = parcelRequire("hrAmX");


var $bSvtO = parcelRequire("bSvtO");


var $cMvMc = parcelRequire("cMvMc");


var $dANtQ = parcelRequire("dANtQ");


var $hl1Kw = parcelRequire("hl1Kw");


var $kRW4Y = parcelRequire("kRW4Y");


var $ep3mz = parcelRequire("ep3mz");


var $a8ZQ3 = parcelRequire("a8ZQ3");





var $lEDve = parcelRequire("lEDve");


var $dj3mI = parcelRequire("dj3mI");


var $2zMIV = parcelRequire("2zMIV");


var $bEdUx = parcelRequire("bEdUx");

const $4bc8108bdabc4896$var$MARGIN_FROM_NODE = 12;
function $4bc8108bdabc4896$export$cfa2225e87938781(node) {
    if (!node) return null;
    if (node.nodeType !== Node.TEXT_NODE && node.scrollWidth > node.clientWidth) return node;
    else return $4bc8108bdabc4896$export$cfa2225e87938781(node.parentNode);
}
function $4bc8108bdabc4896$export$4e12058fc4d51d56(node) {
    if (!node) return null;
    if (node.nodeType !== Node.TEXT_NODE) return node;
    else return $4bc8108bdabc4896$export$4e12058fc4d51d56(node.parentNode);
}
const $4bc8108bdabc4896$export$1690e12b840569b9 = (range)=>{
    const contentRect = $4bc8108bdabc4896$export$4e12058fc4d51d56(range.commonAncestorContainer).getBoundingClientRect();
    const portalContainer = document.querySelector(`#${(0, $bEdUx.popupPortalContainerId)}`);
    const portalRect = portalContainer?.getBoundingClientRect() || {
        left: 0,
        top: 0
    };
    const rect = range.getBoundingClientRect();
    const { left: leftRect, top: top, width: width } = rect;
    // Popup can't be rendered outside the body area
    let leftLimit = contentRect.left;
    let rightLimit = contentRect.right;
    // If the selected text has a parent that is scrollable for example like text inside table.
    // The popup is limited to be shown within the scrollable area.
    const firstParentThatCanScroll = $4bc8108bdabc4896$export$cfa2225e87938781(range.startContainer);
    if (firstParentThatCanScroll) {
        const scrollParentRect = firstParentThatCanScroll.getBoundingClientRect();
        leftLimit = Math.max(leftLimit, scrollParentRect.left);
        rightLimit = Math.min(rightLimit, scrollParentRect.right);
    }
    let x = width / 2 + leftRect;
    x = Math.max(leftLimit, Math.min(rightLimit, x));
    return {
        left: x - portalRect.left,
        top: top - portalRect.top + $4bc8108bdabc4896$var$MARGIN_FROM_NODE
    };
};



var $6zmDz = parcelRequire("6zmDz");

const $788b4f0a9c21e619$export$d3c8a5eb6ab629eb = ({ contentId: contentId, isArchived: isArchived, contentStatusError: contentStatusError, range: range, isAnnotationAllowed: isAnnotationAllowed, onCommentButtonPress: onCommentButtonPress, needTransition: needTransition, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onCommentButtonMount: onCommentButtonMount })=>{
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [position, setPosition] = (0, $42omo.useState)(null);
    const [{ searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics }] = (0, $hl1Kw.useSearchSessionId)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const [{ contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { canAddComments: canAddComments, contentQueryError: contentQueryError } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId);
    const { documentNeedsUpdate: documentNeedsUpdate, currentDocumentVersion: currentDocumentVersion, publishedDocumentVersion: publishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { selectionProps: selectionProps } = (0, $cZa7r.useAnnotations)();
    const { handleClose: handleClose } = (0, $cZa7r.useAnnotationsDispatch)();
    const mountedRef = (0, $42omo.useRef)(false);
    const screenEventFiredRef = (0, $42omo.useRef)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $42omo.useEffect)(()=>{
        if (range) {
            const pos = (0, $4bc8108bdabc4896$export$1690e12b840569b9)(range);
            setPosition(pos);
        } else setPosition(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        range
    ]);
    const createReactInlineCommentHighlight = (0, $42omo.useCallback)(()=>{
        if (isObjectSidebarShown) hideObjectSidebar();
        if ((0, $6mKj3.expValEquals)('confluence_comment_unmount_onmedia_selection', 'isEnabled', true)) {
            if (selectionProps) handleClose();
        }
        onCommentButtonPress && onCommentButtonPress();
    }, [
        isObjectSidebarShown,
        hideObjectSidebar,
        selectionProps,
        handleClose,
        onCommentButtonPress
    ]);
    const handleCommentButtonClick = (dialogs)=>{
        if (hasContentChanged) dialogs.showDialog((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                createReactInlineCommentHighlight();
            }
        });
        else createReactInlineCommentHighlight();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'highlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createInlineCommentFromHighlightActionsMenu',
                type: 'ui',
                attributes: {
                    contentId: contentId,
                    pageMode: 'view',
                    searchSessionId: searchSessionId,
                    ...additionalAnalytics
                }
            }
        }).fire();
    };
    const createInlineCommentButton = ()=>{
        onCommentButtonMount && onCommentButtonMount();
        const needsUpdateToComment = !!documentNeedsUpdate && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated', 'isEnabled', true) || currentDocumentVersion !== publishedDocumentVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true);
        const isCreateButtonEnabled = !isArchived && canAddComments && !needsUpdateToComment && isAnnotationAllowed;
        const createButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $kRW4Y.DialogsStateContainer)
            ]
        }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
                appearance: "subtle",
                "data-key": "com.atlassian.confluence.plugins.confluence-inline-comments:create-inline-comment" // Needed for integration tests
                ,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                    label: "",
                    spacing: "spacious"
                }),
                isDisabled: !isCreateButtonEnabled,
                testId: "createInlineCommentButton",
                onClick: ()=>{
                    handleCommentButtonClick(dialogs);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                id: "highlight-actions.inline-comments.comment",
                defaultMessage: "Comment"
            })));
        // WS-2802 - We need to wrap the disabled button and put a transparent absolute overlay over the button
        //           in order to show the tooltip correctly as the disabled button swallows all events on the element
        return isCreateButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
            key: "inline-comment-button"
        }, createButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            delay: 0,
            position: "top",
            content: (0, $dj3mI.getCreateButtonDisabledMessage)(isArchived, canAddComments, needsUpdateToComment, contentType)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonWrapper), {
            key: "inline-comment-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.DisabledButtonOverlay), null), createButton));
    };
    const renderPopup = (component)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: [
                (0, $hrAmX.BannerStateContainer)
            ]
        }, (bannerState)=>{
            // if there's a sticky header we want to position the toolbar below
            // the nav, the page header (if visible) and the sticky header
            let stickyHeaderHeight = 0;
            const range = (0, $2zMIV.getRange)();
            if (range) {
                const header = (0, $2zMIV.findStickyHeader)(range.commonAncestorContainer);
                if (header && bannerState) stickyHeaderHeight = bannerState.getTotalHeight() + header.clientHeight;
            }
            if (!screenEventFiredRef.current) createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'highlightActionsMenu',
                    attributes: {
                        contentId: contentId
                    }
                }
            }).fire();
            screenEventFiredRef.current = true;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, position && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lEDve.Popup), {
                top: stickyHeaderHeight + position.top,
                left: position.left,
                needTransition: needTransition,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave
            }, component), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_EXPERIENCE)
            }));
        });
    const error = contentStatusError || contentQueryError;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        id: contentId,
        name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_EXPERIENCE)
    }), renderPopup(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6zmDz.BuiltInActionsSimple), {
        key: "built-in-actions"
    }, createInlineCommentButton()))));
};






var $afGoD = parcelRequire("afGoD");





var $8Mzkb = parcelRequire("8Mzkb");

const $dd9a461270565732$var$findAnnotationElement = (target)=>{
    // Scan through the parents to the root of the renderer looking for an annotation mark. If we find one then the
    // comment pressing the comment button will instead cause the comment view to open the discovered annotation.
    let element = target.parentElement;
    while(element && !element.classList.contains('ak-renderer-wrapper')){
        if (element.dataset.markType === 'annotation' && element.dataset.markAnnotationState !== 'resolved') return element;
        element = element.parentElement;
    }
    return null;
};
const $dd9a461270565732$export$e394de0b31ec5273 = /*#__PURE__*/ (0, $42omo.memo)(({ pageId: pageId, updateDocument: updateDocument, wrapperDOM: wrapperDOM, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, onCreate: onCreate, onClose: onClose, applyDraftMode: applyDraftMode, removeDraftMode: removeDraftMode, onCommentButtonMount: onCommentButtonMount, isOffline: isOffline = false })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const showHighlightActionsTimeoutRef = (0, $42omo.useRef)();
    const annotationId = (0, $42omo.useRef)('');
    const annotationExists = (0, $42omo.useRef)(false);
    const annotationElement = (0, $42omo.useRef)(null);
    const [showHighlightActions, setShowHighlightActions] = (0, $42omo.useState)(false);
    const [showCreateComponent, setShowCreateComponent] = (0, $42omo.useState)(false);
    const [selectionOptions, setSelectionOptions] = (0, $42omo.useState)();
    const [stepGenerationError, setStepGenerationError] = (0, $42omo.useState)(false);
    const { isInReattachMode: isInReattachMode } = (0, $42omo.useContext)((0, $brNvA.ReattachCommentContext));
    const [isOnCommentButton, setIsOnCommentButton] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        // If we're in reattach mode or we have no selection do nothing
        if (isInReattachMode() || !range) return;
        if (showHighlightActionsTimeoutRef.current) clearTimeout(showHighlightActionsTimeoutRef.current);
        showHighlightActionsTimeoutRef.current = setTimeout(()=>{
            setShowHighlightActions(true);
            const dismissHighlight = ()=>{
                setShowHighlightActions(false);
                document.querySelector('#content-body')?.removeEventListener('click', dismissHighlight);
            };
            document.querySelector('#content-body')?.addEventListener('click', dismissHighlight);
        }, 500);
    }, [
        range,
        showHighlightActionsTimeoutRef,
        isInReattachMode
    ]);
    let isInPageInclude = null;
    if (range.startContainer instanceof HTMLElement) isInPageInclude = range.startContainer.closest('[data-node-type="include"]');
    (0, $42omo.useEffect)(()=>{
        const annotation = $dd9a461270565732$var$findAnnotationElement(range.startContainer);
        if (annotation?.dataset.id) {
            annotationId.current = annotation.dataset.id;
            annotationExists.current = true;
        } else {
            annotationId.current = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
            annotationExists.current = false;
        }
        // TODO: Remove this once wrapperDom works correctly
        if (range.startContainer.nodeType === Node.TEXT_NODE) annotationElement.current = range.startContainer.parentElement;
        else annotationElement.current = range.startContainer;
    }, [
        range
    ]);
    (0, $42omo.useEffect)(()=>{
        // Whenever the pageId changes, we need to close anything that's open
        return ()=>{
            handleClose();
        };
    // We only want to listen to the pageId changing
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageId
    ]);
    const onCommentButtonPress = ()=>{
        if (annotationExists.current) {
            // Tell the renderer to set the existing comment to active rather then creating a new comment
            (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                annotationIds: [
                    annotationId.current
                ],
                eventTarget: document.getElementById(annotationId.current),
                // use mediaSingle here to align with annotation viewed event dispatched in editor
                eventTargetType: 'mediaSingle',
                viewMethod: 'commentButton'
            });
            handleClose();
            return;
        }
        if ((0, $9wGTI.fg)('confluence_fe_create_inline_comment_exp_coverage')) {
            (0, $3YBks.createInlineCommentCompoundExperience).start({
                attributes: {
                    pageClass: 'renderer',
                    commentType: 'block',
                    blockType: 'media',
                    annotationId: annotationId.current,
                    entryPoint: 'highlightActionsSimple'
                }
            });
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.start();
        }
        const result = applyDraftMode({
            annotationId: annotationId.current,
            keepNativeSelection: false
        });
        if (result) {
            setSelectionOptions({
                step: result.step,
                originalSelection: result.originalSelection,
                numMatches: result.numMatches,
                matchIndex: result.matchIndex,
                createdFrom: (0, $afGoD.CommentCreationLocation).RENDERER,
                targetNodeType: result.targetNodeType
            });
            if ((0, $6mKj3.expValEquals)('confluence_prevent_double_comment_sidebar_renderer', 'isEnabled', true)) (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
        } else setStepGenerationError(true);
        /*
     * Set a timeout to allow the draft annotation to be applied before showing the create component.
     * This is important for draft annotations on images. Without this, the offset will be calculated incorrectly
     * and the create component will appear at the top of the page, rather than at the location of the annotation.
     */ setTimeout(()=>setShowCreateComponent(true), 0);
    };
    const handleSaveSuccess = (aId)=>{
        setStepGenerationError(false);
        setSelectionOptions(undefined);
        // Since we generated the uuid ourselves, we need to replace the document generated with
        // the annotationId that we received from the backend so things line up correctly
        const result = onCreate(aId);
        if (result) {
            removeDraftMode();
            updateDocument && updateDocument(result.doc);
            setTimeout(()=>{
                // Tell the renderer to set the new comment to active
                (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        aId
                    ],
                    // eventTarget: wrapperDOM,
                    eventTarget: document.getElementById(aId)
                });
                experienceTracker.succeed({
                    name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE)
                });
            // We need the timeout to give the document the chance to make the marks properly
            }, 1000);
        }
    };
    const handleClose = (0, $42omo.useCallback)(()=>{
        setShowCreateComponent(false);
        setStepGenerationError(false);
        setSelectionOptions(undefined);
        onClose();
    }, [
        setShowCreateComponent,
        setStepGenerationError,
        setSelectionOptions,
        onClose
    ]);
    // Show an error message if the generation of a step caused an error
    stepGenerationError;
    if (showCreateComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Mzkb.CreateComment), {
        pageId: pageId,
        annotationElement: wrapperDOM,
        selectionOptions: selectionOptions,
        onCreate: handleSaveSuccess,
        onClose: handleClose,
        isOffline: isOffline
    });
    // We should auto dismiss the comment button when mouse is not within the hover target and not on the comment button
    const shouldDismiss = !isWithinRange && !isOnCommentButton;
    return !isInPageInclude && showHighlightActions && !shouldDismiss ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $788b4f0a9c21e619$export$d3c8a5eb6ab629eb), {
        contentId: pageId,
        range: range,
        isAnnotationAllowed: isAnnotationAllowed,
        onCommentButtonPress: onCommentButtonPress,
        needTransition: false,
        onMouseEnter: ()=>{
            setIsOnCommentButton(true);
        },
        onMouseLeave: ()=>{
            setIsOnCommentButton(false);
        },
        onCommentButtonMount: onCommentButtonMount
    }) : null;
});









var $cUycv = parcelRequire("cUycv");


var $1pSma = parcelRequire("1pSma");











var $liGyh = parcelRequire("liGyh");


var $9FoVw = parcelRequire("9FoVw");





var $8aF6s = parcelRequire("8aF6s");








var $5fMeR = parcelRequire("5fMeR");


var $6KwrO = parcelRequire("6KwrO");


var $3mVfX = parcelRequire("3mVfX");








var $aJPUt = parcelRequire("aJPUt");


var $4EKKB = parcelRequire("4EKKB");


var $gtj7V = parcelRequire("gtj7V");


var $2UZkz = parcelRequire("2UZkz");

const $286e4a58224268a3$var$relativeFilePath = 'annotation-provider-inline-comments/renderer/ViewComponent';
const $286e4a58224268a3$export$1ae47b8b2d387d0a = (eventEmitter, newSelection)=>{
    if (newSelection) eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
        annotationId: newSelection
    });
    else {
        eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
        eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
    }
};
const $286e4a58224268a3$export$f845437bf1d007fd = /*#__PURE__*/ (0, $42omo.memo)(({ annotations: clickedAnnotations, getInlineNodeTypes: getInlineNodeTypes, deleteAnnotation: deleteAnnotation, pageId: pageId, updateDocument: updateDocument, isArchived: isArchived, isOffline: isOffline, wasHighlightClicked: wasHighlightClicked, pageContainsBodiedMacros: pageContainsBodiedMacros })=>{
    const viewInlineCommentPressTrace = (0, $1pSma.default)('view-inline-comment-action');
    const { documentUpdated: documentUpdated } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { clearStoredCommentData: clearStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    const [selectedAnnotation, setSelectedAnnotation] = (0, $42omo.useState)(null);
    const [eventEmitter] = (0, $42omo.useState)((0, $gczDe.getRendererAnnotationEventEmitter)());
    const prevPageIdRef = (0, $42omo.useRef)(pageId);
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const [isInlineCommentVisible, setIsInlineCommentVisible] = (0, $42omo.useState)(false);
    const inlineCommentRef = (0, $42omo.useCallback)((node)=>{
        if (node === null) setIsInlineCommentVisible(false);
        else setIsInlineCommentVisible(true);
    }, []);
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCurrentView: setCurrentView } = (0, $3mVfX.useCommentsPanelActions)();
    const { currentView: currentView } = (0, $3mVfX.useCommentsPanelState)();
    const { scrollCommentsPanelToThread: scrollCommentsPanelToThread } = (0, $6KwrO.useCommentsPanelScroll)();
    const { isCommentsPanelShown: isCommentsPanelShown } = (0, $5fMeR.useShowCommentsPanel)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const supportedActions = pageContainsBodiedMacros && !(0, $9wGTI.fg)('confluence_comment_nested_renderer_delete') ? [
        'edit',
        'resolve'
    ] : [
        'edit',
        'resolve',
        'delete'
    ];
    const handleAnnotationClick = (0, $42omo.useCallback)((annotation)=>{
        // If the current annotation has been clicked again
        if (selectedAnnotation && annotation && selectedAnnotation.id === annotation.id) {
            // Send an event to tell the Renderer to de-select the annotation
            $286e4a58224268a3$export$1ae47b8b2d387d0a(eventEmitter);
            setSelectedAnnotation(null);
            if (isCommentsPanelShown && (0, $9wGTI.fg)('confluence-frontend-comments-panel')) setCurrentlySelectedThreadKey('');
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_renderer')) experienceTracker.abort({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                reason: 'Current annotation was clicked again. Annotation was deselected',
                checkForTimeout: true,
                publishDebugPoints: true,
                attributes: {
                    stopPoint: $286e4a58224268a3$var$relativeFilePath
                }
            });
        } else {
            viewInlineCommentPressTrace();
            // Only start the experience if the comments panel is closed to track the core view-inline-comment experience
            if (!isCommentsPanelShown && annotation?.id && (0, $9wGTI.fg)('confluence_frontend_view_inline_comment_renderer')) {
                const experienceState = experienceTracker.getExperienceState((0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE));
                /*
						 * Note: This logic runs after certain entrypoints start the view-inline-comment experience.
						 * We don't start a new experience if the annotation ID of the running experience is the same
						 * as the current annotation to avoid duplicating and aborting experiences.
						 */ if (experienceState === null || experienceState?.hasStopped || experienceState?.hasStopped === false && experienceState?.attributes?.annotationId !== annotation?.id) experienceTracker.start({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        annotationId: annotation?.id,
                        entryPoint: $286e4a58224268a3$var$relativeFilePath,
                        pageClass: 'renderer',
                        prevSelectedAnnotationId: selectedAnnotation?.id ?? null
                    }
                });
            }
            // Send an event to tell the renderer to select the annotation
            $286e4a58224268a3$export$1ae47b8b2d387d0a(eventEmitter, annotation?.id);
            // Select it in our code
            setSelectedAnnotation(annotation);
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_debug')) (0, $4EKKB.selectInlineComment).debug(`handleAnnotationClick setSelectedAnnotation to ${annotation?.id}, isCommentsPanelShown: ${isCommentsPanelShown}`);
            const shouldSetSelectedCommentMarkerRef = isCommentsPanelShown && annotation;
            if (shouldSetSelectedCommentMarkerRef && (0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                setCurrentlySelectedThreadKey(annotation.id);
                let expectedView = undefined;
                if (currentView === (0, $3mVfX.ViewValues).RESOLVED || currentView === (0, $3mVfX.ViewValues).DELETED_CONTENT) {
                    expectedView = (0, $3mVfX.ViewValues).OPEN;
                    setCurrentView && setCurrentView((0, $3mVfX.ViewValues).OPEN);
                }
                if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                    scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                    context: (0, $9FoVw.NavigationContext).PANEL,
                    block: 'center',
                    annotationId: annotation.id,
                    annotationClicked: true,
                    expectedView: expectedView
                });
                else scrollCommentsPanelToThread({
                    annotationId: annotation.id,
                    annotationClicked: true
                });
            }
        }
    }, [
        eventEmitter,
        selectedAnnotation,
        isCommentsPanelShown,
        setSelectedAnnotation,
        setCurrentlySelectedThreadKey,
        scrollCommentsPanelToThread,
        experienceTracker,
        viewInlineCommentPressTrace,
        setCurrentView,
        currentView
    ]);
    const onNavigationClick = (0, $42omo.useCallback)((nextMarkerRef)=>{
        if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_arrow_nav')) experienceTracker.updateAttributes({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                annotationId: nextMarkerRef
            }
        });
        const doNavigation = async ()=>{
            handleAnnotationClick({
                id: nextMarkerRef,
                type: (0, $cUycv.AnnotationTypes).INLINE_COMMENT
            });
        };
        if (hasContentChanged) {
            let abortedCommentNavigationExperience = false;
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_arrow_nav')) {
                const experienceState = experienceTracker.getExperienceState((0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE));
                /*
						 * If the comment navigation is used to navigate when the content has changed, we abort and restart
						 * the experience on confirm because we can't predict if the user will confirm the navigation, or
						 * how long the user will take to confirm.
						 */ if (experienceState !== null && experienceState?.hasStopped === false && experienceState?.attributes?.entryPoint === 'inline-comments-common/CommentNavigation') {
                    experienceTracker.abort({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        reason: 'Comment warning dialog displayed',
                        checkForTimeout: true,
                        publishDebugPoints: true,
                        attributes: {
                            stopPoint: $286e4a58224268a3$var$relativeFilePath
                        }
                    });
                    abortedCommentNavigationExperience = true;
                }
            }
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    if (abortedCommentNavigationExperience) {
                        experienceTracker.start({
                            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                            timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                            attributes: {
                                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                                annotationId: nextMarkerRef,
                                entryPoint: $286e4a58224268a3$var$relativeFilePath,
                                pageClass: 'renderer'
                            }
                        });
                        experienceTracker.attachDebugPoint({
                            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                            message: 'Restarting experience after comment was discarded from comment warning dialog. Initial entrypoint: inline-comments-common/CommentNavigation'
                        });
                    }
                    resetContentChanged();
                    doNavigation();
                }
            });
        } else doNavigation();
    }, [
        hasContentChanged,
        handleAnnotationClick,
        resetContentChanged,
        showModal,
        experienceTracker
    ]);
    (0, $42omo.useEffect)(()=>{
        // When clickedAnnotations.length is 0, it's unclear why we setSelectedAnnotation(null) only
        // when !selectedAnnotation. This is likely a bug. This flag switched ON removes this odd check.
        if (!clickedAnnotations.length && (!selectedAnnotation || (0, $9wGTI.fg)('confluence_frontend_view_inline_comment_debug'))) {
            setSelectedAnnotation(null);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_renderer')) {
                if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_debug')) (0, $4EKKB.selectInlineComment).debug(`clickedAnnotations.length is 0, selectedAnnotationId: ${selectedAnnotation?.id}`);
                /*
					 * Handle the case where the annotation is quickly deselected before the
					 * renderer has a chance to render the inline comment. This can happen when
					 * the user double clicks on an annotation, the user navigates via keyboard
					 * shortcut to a general comment, or the inline comment is unmounted.
					 */ experienceTracker.abort({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    reason: 'No annotation selected. Annotation was likely deselected.',
                    checkForTimeout: true,
                    publishDebugPoints: true,
                    attributes: {
                        stopPoint: $286e4a58224268a3$var$relativeFilePath
                    }
                });
            }
            return;
        }
        // Multi-selection to be implemented in future
        const newlySelectedAnnotation = clickedAnnotations[0];
        if (documentUpdated && !wasHighlightClicked) {
            if (selectedAnnotation?.id === newlySelectedAnnotation?.id) return;
        }
        // Invoke handleAnnotationClick only if highlight was clicked.
        // The if block above can be removed too when cleaning up this flag.
        if (wasHighlightClicked || !(0, $9wGTI.fg)('confluence_frontend_view_inline_comment_debug_v2')) handleAnnotationClick(newlySelectedAnnotation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clickedAnnotations
    ]);
    (0, $42omo.useEffect)(()=>{
        const prevPageId = prevPageIdRef.current;
        // Whenever the pageId changes, we need to close anything that's open
        if (pageId !== prevPageId) handleOnClose();
        return ()=>{
            if (pageId !== prevPageId) handleOnClose();
        };
    // We only want to listen to the pageId changing
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageId
    ]);
    const handleOnClose = (0, $42omo.useCallback)(()=>{
        // Inform the Renderer to de-select the annotation
        eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
        eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
        // Remove the display of the comment
        setSelectedAnnotation(null);
        removeCommentQueryParams();
        if (storedCommentData) clearStoredCommentData();
        if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_renderer')) experienceTracker.abort({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            reason: 'Inline comment was closed',
            checkForTimeout: true,
            publishDebugPoints: true,
            attributes: {
                stopPoint: $286e4a58224268a3$var$relativeFilePath
            }
        });
    }, [
        eventEmitter,
        setSelectedAnnotation,
        removeCommentQueryParams,
        experienceTracker,
        storedCommentData,
        clearStoredCommentData
    ]);
    const onDeleteSuccess = (doc)=>{
        if (doc) {
            // Inform the Renderer to de-select the annotation
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            updateDocument && updateDocument(doc);
        }
    };
    const shouldRenderStandaloneInlineComment = selectedAnnotation && (!(0, $9wGTI.fg)('confluence-frontend-comments-panel') || !isCommentsPanelShown);
    return shouldRenderStandaloneInlineComment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2UZkz.InlineComment), {
        annotation: selectedAnnotation,
        getInlineNodeTypes: getInlineNodeTypes,
        isArchived: isArchived,
        onClose: handleOnClose,
        onResolve: ()=>{},
        deleteOptions: {
            deleteAnnotation: deleteAnnotation,
            onDeleteSuccess: onDeleteSuccess
        },
        onNavigationClick: onNavigationClick,
        supportedTopLevelActions: supportedActions,
        inlineCommentRef: inlineCommentRef,
        isInlineCommentVisible: isInlineCommentVisible,
        isOffline: isOffline,
        key: `inline-comment-${selectedAnnotation?.id}`
    }) : null;
});






var $iu6m9 = parcelRequire("iu6m9");











var $8Ss4E = parcelRequire("8Ss4E");





var $24amZ = parcelRequire("24amZ");

var $l2hqi = parcelRequire("l2hqi");


var $2Awp2 = parcelRequire("2Awp2");





var $bQm3c = parcelRequire("bQm3c");




const $fb59c4e491ffb95c$export$cf6655f87eaeee23 = /*#__PURE__*/ (0, $42omo.memo)(({ pageId: pageId, isArchived: isArchived, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, contentType: contentType, inlineNodeTypes: inlineNodeTypes, lastModifiedDate: lastModifiedDate, onCommentButtonMount: onCommentButtonMount, isOffline: isOffline = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isInReattachMode: isInReattachMode } = (0, $42omo.useContext)((0, $brNvA.ReattachCommentContext));
    const { setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor, setShowHighlightActions: setShowHighlightActions, setShowCreateComponent: setShowCreateComponent, handleSaveSuccess: handleSaveSuccess, handleClose: handleClose } = (0, $cZa7r.useAnnotationsDispatch)();
    const { showCreateComponent: showCreateComponent, showHighlightActions: showHighlightActions, selectionOptions: selectionOptions, stepGenerationError: stepGenerationError } = (0, $cZa7r.useAnnotations)();
    const annotationElement = (0, $42omo.useRef)(null);
    const prevPageIdRef = (0, $42omo.useRef)(pageId);
    const [allowAnnotationOnSelection, setAllowAnnotationOnSelection] = (0, $42omo.useState)(isAnnotationAllowed);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    (0, $42omo.useEffect)(()=>{
        // If we're in reattach mode or we have no selection do nothing
        if (isInReattachMode() || !range) {
            setShowHighlightActions(false);
            return;
        }
        const { startContainer: startContainer, endContainer: endContainer } = range;
        let nodeToCheck = null;
        // If we're highlighting an inline-extension, don't allow annotations
        // Check the startContainer first
        if (startContainer.nodeType === Node.TEXT_NODE) nodeToCheck = startContainer.parentElement;
        else nodeToCheck = startContainer;
        if (nodeToCheck && nodeToCheck.closest('.ak-renderer-extension')) {
            if ((0, $iu6m9.editorExperiment)('comment_on_bodied_extensions', true, {
                exposure: true
            })) // `:not(:has(` currently causes nwsapi to fail (used in jsdom)
            // so the following is a workaround until that is fixed
            {
                if (!nodeToCheck.closest('.ak-renderer-extension')?.querySelector('[data-inline-comments-target=true]')) {
                    setAllowAnnotationOnSelection(false);
                    setShowHighlightActions(true);
                    return;
                }
            } else {
                setAllowAnnotationOnSelection(false);
                setShowHighlightActions(true);
                return;
            }
        }
        // Next check the endContainer if the start wasn't on an inline-extension
        if (endContainer.nodeType === Node.TEXT_NODE) nodeToCheck = endContainer.parentElement;
        else nodeToCheck = endContainer;
        if (nodeToCheck && nodeToCheck.closest('.ak-renderer-extension')) {
            if ((0, $iu6m9.editorExperiment)('comment_on_bodied_extensions', true, {
                exposure: true
            })) {
                // `:not(:has(` currently causes nwsapi to fail (used in jsdom)
                // so the following is a workaround until that is fixed
                if (!nodeToCheck.closest('.ak-renderer-extension')?.querySelector('[data-inline-comments-target=true]')) setAllowAnnotationOnSelection(false);
                else // If everything passes, set it to what was passed by the annotationProvider
                setAllowAnnotationOnSelection(isAnnotationAllowed);
            } else setAllowAnnotationOnSelection(false);
        } else if (nodeToCheck?.closest('[data-sync-block-renderer]') && (0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) setAllowAnnotationOnSelection(false);
        else // If everything passes, set it to what was passed by the annotationProvider
        setAllowAnnotationOnSelection(isAnnotationAllowed);
        setShowHighlightActions(true);
    }, [
        range,
        isAnnotationAllowed,
        isInReattachMode,
        setShowHighlightActions,
        setAllowAnnotationOnSelection
    ]);
    // TODO: Fix me
    // This currently doesn't do anything to position the sidebar
    // We SHOULD be calculating this annotationElement and positioning based on it
    (0, $42omo.useEffect)(()=>{
        if (!draftRange) return;
        const rangeContainer = draftRange?.startContainer;
        if (rangeContainer) {
            if (rangeContainer.nodeType === Node.TEXT_NODE) annotationElement.current = rangeContainer.parentElement;
            else annotationElement.current = rangeContainer;
        }
    }, [
        draftRange
    ]);
    (0, $42omo.useEffect)(()=>{
        const showCreateComponent = Boolean(selectionOptions);
        if (showCreateComponent) (0, $8Ss4E.startEditorExperiences)({
            name: (0, $irVI7.ADD_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                mode: (0, $l2hqi.InlineCommentMode).VIEW,
                framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                edition: edition
            }
        }, {
            name: (0, $irVI7.ADD_INLINE_COMMENT_LOAD_EXPERIENCE)
        }, {
            name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE)
        });
        setShowCreateComponent(showCreateComponent);
    }, [
        edition,
        selectionOptions,
        pageId,
        createAnalyticsEvent,
        setShowCreateComponent
    ]);
    (0, $42omo.useEffect)(()=>{
        const prevPageId = prevPageIdRef.current;
        // Whenever the pageId changes, we need to close anything that's open
        if (pageId !== prevPageId) handleClose();
        return ()=>{
            if (pageId !== prevPageId) handleClose();
        };
    // We only want to listen to the pageId changing
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageId
    ]);
    const handleCommentButtonPress = (0, $42omo.useCallback)(()=>{
        setSelectionOptionsForCreateEditor({
            experienceAttributes: {
                entryPoint: 'highlightActions'
            }
        });
    }, [
        setSelectionOptionsForCreateEditor
    ]);
    // Show an error message if the generation of a step caused an error
    stepGenerationError;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, showCreateComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Mzkb.CreateComment), {
        pageId: pageId,
        annotationElement: wrapperDOM,
        selectionOptions: selectionOptions,
        onCreate: (annotationId, commentData)=>{
            handleSaveSuccess(annotationId, commentData);
        },
        onClose: handleClose,
        isOffline: isOffline
    }), range && showHighlightActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Awp2.HighlightActions), {
        contentId: pageId,
        range: range,
        isAnnotationAllowed: allowAnnotationOnSelection,
        onCommentButtonPress: handleCommentButtonPress,
        isArchived: isArchived,
        contentType: contentType,
        inlineNodeTypes: inlineNodeTypes,
        isFabric: true,
        lastModifiedDate: lastModifiedDate,
        onCommentButtonMount: onCommentButtonMount
    }));
});



var $iVane = parcelRequire("iVane");

/**
 * @graphql cc
 */ 



var $eSUdr = parcelRequire("eSUdr");


var $diswb = parcelRequire("diswb");


var $cgtv4 = parcelRequire("cgtv4");







var $4u5NT = parcelRequire("4u5NT");








var $8i27m = parcelRequire("8i27m");








var $aHcFH = parcelRequire("aHcFH");





var $7W8i8 = parcelRequire("7W8i8");


var $7Sm4c = parcelRequire("7Sm4c");





var $6eFi0 = parcelRequire("6eFi0");











var $i6UMJ = parcelRequire("i6UMJ");





var $8WQTF = parcelRequire("8WQTF");


var $kgNLQ = parcelRequire("kgNLQ");


var $lb2Lp = parcelRequire("lb2Lp");


var $aSsfA = parcelRequire("aSsfA");




const $b6108840e0d320f3$var$TIMEOUT_TO_STOP_CHECKING_FOR_MUTATIONS_AND_INTERACTION = 20000;
const $b6108840e0d320f3$var$USER_INTERACTION_EVENTS = [
    'mousedown',
    'keydown',
    'wheel',
    'touchstart'
];
const $b6108840e0d320f3$export$544875121493f258 = ({ callback: callback, elementRef: elementRef, skip: skip })=>{
    const stopObserverCallbacks = (0, $42omo.useRef)([]);
    const mutationEndTimer = (0, $42omo.useRef)(0);
    const stopMonitoring = (0, $42omo.useCallback)((_reason)=>{
        stopObserverCallbacks.current.forEach((stop)=>{
            stop();
        });
        stopObserverCallbacks.current = [];
        if (mutationEndTimer.current !== 0) {
            window.clearTimeout(mutationEndTimer.current);
            mutationEndTimer.current = 0;
        }
    }, []);
    const startMonitoring = (0, $42omo.useCallback)(()=>{
        if (!stopObserverCallbacks.current.length && elementRef?.current) {
            const mutationObserver = new MutationObserver(()=>{
                // Every time there's a change, restart the timer that ends watching for mutations
                // (keep the observer going until changes stop for a while).
                window.clearTimeout(mutationEndTimer.current);
                mutationEndTimer.current = window.setTimeout(()=>{
                    // De-bouncing ended. Timeout finally running, time to stop observing and trying to follow the anchor
                    stopMonitoring('Deep link target never found');
                }, $b6108840e0d320f3$var$TIMEOUT_TO_STOP_CHECKING_FOR_MUTATIONS_AND_INTERACTION);
                if (callback()) // If the callback succeeded, stop monitoring
                stopMonitoring('Callback succeeded');
            });
            mutationObserver.observe(elementRef.current, {
                childList: true,
                subtree: true,
                attributes: true,
                characterData: true
            });
            stopObserverCallbacks.current.push(()=>{
                mutationObserver.disconnect();
            });
            // Listen for user interaction to end checking for changes
            $b6108840e0d320f3$var$USER_INTERACTION_EVENTS.forEach((name)=>{
                const userInteractionHandler = ()=>stopMonitoring('User interaction');
                window.addEventListener(name, userInteractionHandler, true);
                stopObserverCallbacks.current.push(()=>{
                    window.removeEventListener(name, userInteractionHandler, true);
                });
            });
        }
    }, [
        elementRef,
        callback,
        stopMonitoring
    ]);
    (0, $42omo.useEffect)(()=>{
        // Do nothing if skip is true or the elementRef is not set.
        if (skip || !elementRef?.current) return;
        // Try right away in case the page has already settled and there are no mutations to observe.
        if (callback()) return;
        // Watch for changes to the page and call the callback whenever one occurs.
        startMonitoring();
        return ()=>{
            stopMonitoring('Canceled by unmount');
        };
    }, [
        elementRef,
        callback,
        skip,
        startMonitoring,
        stopMonitoring
    ]);
};



var $eTcMK = parcelRequire("eTcMK");

const $61084f20d36cc3f6$var$InlineCommentQueryParamsListenerInlineCommentQueryParamsQuery = (0, $eSUdr.default)`query InlineCommentQueryParamsListenerInlineCommentQueryParamsQuery($commentId:ID!){comments(commentId:$commentId){nodes{id author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}location{type ...on InlineComment{inlineMarkerRef inlineResolveProperties{resolved}}}ancestors{id author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}location{type ...on InlineComment{inlineMarkerRef inlineResolveProperties{resolved}}}}parentId}}}`;
const $61084f20d36cc3f6$var$logger = (0, $7W8i8.getLogger)('inline-comments:query-param-listener');
const $61084f20d36cc3f6$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    commentLinkNotFoundFlagTitle: {
        id: "comments-query-param-handlers.comment-link-not-found.flag.title",
        defaultMessage: "This comment is not available"
    },
    commentLinkNotFoundFlagDescription: {
        id: "comments-query-param-handlers.comment-link-not-found.flag.description",
        defaultMessage: "It may be deleted."
    }
});
const $61084f20d36cc3f6$export$3cf51438c4a7a1a = ({ isArchived: isArchived, rendererRef: rendererRef, flags: flags })=>{
    const [isResolveDialogShown, setIsResolveDialogShown] = (0, $42omo.useState)(false);
    const hasHandledCommentLink = (0, $42omo.useRef)(false);
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { focusedCommentId: focusedCommentId, replyToCommentId: replyToCommentId, editCommentId: editCommentId, removeCommentQueryParams: removeCommentQueryParams, isCommentNotFound: isCommentNotFound } = (0, $liGyh.useInlineCommentQueryParams)({
        queryArchivedContent: isArchived
    });
    const { rendererActions: rendererActions } = (0, $8WQTF.useRendererActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCommentContainerToFocus: setCommentContainerToFocus, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const commentId = focusedCommentId || replyToCommentId || editCommentId;
    // NEW FLOW: Use useCommentById hooks when experiment is enabled
    const skipNewFlow = !commentId || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false);
    const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
    const { comment: foundComment, loading: commentLoading, error: commentError } = (0, $lb2Lp.useCommentById)({
        commentId: commentId || '',
        contentId: contentId || '',
        contentStatus: contentStatusFilters,
        options: {
            skip: skipNewFlow
        }
    });
    const { comment: parentComment, loading: parentLoading, error: parentError } = (0, $lb2Lp.useCommentById)({
        commentId: foundComment?.parentId || '',
        contentId: contentId || '',
        contentStatus: contentStatusFilters,
        options: {
            skip: skipNewFlow || !foundComment?.parentId
        }
    });
    // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)($61084f20d36cc3f6$var$InlineCommentQueryParamsListenerInlineCommentQueryParamsQuery, {
        variables: {
            commentId: commentId
        },
        skip: !commentId || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    });
    if (error) {
        $61084f20d36cc3f6$var$logger.error`An error occurred when querying the focused comment status; ${error}`;
        // TODO: If this query fails, there isn't much we can do, so just track it with experience tracker?
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const queryParamData = (0, $42omo.useMemo)(()=>{
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            // NEW FLOW: Extract data from useCommentById hooks
            if (!commentError && !commentLoading && foundComment) {
                const location = foundComment.location;
                const parentId = foundComment.parentId;
                const parentLocation = parentId && !parentError && !parentLoading && parentComment ? parentComment.location : undefined;
                return {
                    location: location,
                    parentId: parentId,
                    parentLocation: parentLocation
                };
            }
            return undefined;
        } else {
            // OLD FLOW: Extract data from GraphQL query
            if (!error && !loading && data) {
                const location = data.comments?.nodes?.[0]?.location;
                const parentId = data.comments?.nodes?.[0]?.parentId;
                const parentLocation = data.comments?.nodes?.[0]?.ancestors?.[0]?.location;
                return {
                    location: location,
                    parentId: parentId,
                    parentLocation: parentLocation
                };
            }
            return undefined;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        commentId,
        data,
        loading,
        error,
        foundComment,
        commentLoading,
        commentError,
        parentComment,
        parentLoading,
        parentError
    ]);
    const queryParamDataExt = (0, $42omo.useMemo)(()=>{
        const { location: location, parentLocation: parentLocation } = queryParamData || {};
        return location?.inlineMarkerRef ? {
            annotationId: location.inlineMarkerRef,
            isResolved: Boolean(location.inlineResolveProperties?.resolved)
        } : {
            annotationId: parentLocation?.inlineMarkerRef,
            isResolved: Boolean(parentLocation?.inlineResolveProperties?.resolved)
        };
    }, [
        queryParamData
    ]);
    // Create callback for handling replyToCommentId when comment is rendered
    const onReplyToCommentReady = (0, $42omo.useCallback)(()=>{
        if (!replyToCommentId) return;
        // Get comment data from either new flow or old flow
        const rawComment = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? foundComment : data?.comments?.nodes?.[0];
        if (rawComment) {
            const commentWithAuthor = rawComment;
            // Get annotationId from the reply-to comment's location
            const annotationId = queryParamDataExt?.annotationId;
            // Set the thread key to the annotationId of the parent comment we're replying to
            if (annotationId) setCurrentlySelectedThreadKey(annotationId, (0, $8i27m.CommentType).INLINE);
            // Access author field - both types have this field
            const author = commentWithAuthor?.author;
            // Set up reply state
            setReplyToCommentId((0, $eTcMK.createReplyToCommentParams)(replyToCommentId, (0, $i6UMJ.LocationValue).PANEL, author, (0, $9wGTI.fg)('confluence_frontend_content_wrapper')));
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        replyToCommentId,
        foundComment,
        data,
        queryParamDataExt,
        setReplyToCommentId,
        setCurrentlySelectedThreadKey
    ]);
    const tryToFocusAndScrollActiveCommentCallback = (0, $42omo.useCallback)(()=>{
        return $61084f20d36cc3f6$var$tryToFocusAndScrollActiveComment({
            parentId: queryParamData?.parentId,
            annotationId: queryParamDataExt?.annotationId || null,
            commentId: commentId || null
        });
    }, [
        queryParamData,
        queryParamDataExt,
        commentId
    ]);
    (0, $b6108840e0d320f3$export$544875121493f258)({
        callback: tryToFocusAndScrollActiveCommentCallback,
        elementRef: rendererRef,
        skip: !commentId || !queryParamData || queryParamDataExt.isResolved
    });
    (0, $42omo.useEffect)(()=>{
        if (!queryParamData || hasHandledCommentLink.current) return;
        const { location: location, parentId: parentId } = queryParamData;
        const { annotationId: annotationId } = queryParamDataExt;
        if (location) {
            if (queryParamDataExt.isResolved) {
                if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).RESOLVED
                    });
                    if (annotationId) {
                        setCurrentlySelectedThreadKey(annotationId, (0, $8i27m.CommentType).INLINE);
                        setCommentContainerToFocus(commentId); // we'll be using this to scroll to it using data-comment-id
                    }
                } else if (!isResolveDialogShown) {
                    setIsResolveDialogShown(true);
                    // @ts-expect-error - Incompatible types but works fine
                    showModal((0, $6eFi0.ResolvedInlineCommentsDialogLoader), {
                        context: 'renderer',
                        contentId: contentId,
                        focusedCommentData: {
                            id: commentId,
                            parentCommentId: parentId
                        },
                        onClose: ()=>{
                            removeCommentQueryParams();
                            setIsResolveDialogShown(false);
                        }
                    });
                }
            } else if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                // Check if annotation exists in renderer only when we need to make the decision
                const annotationExists = rendererActions ? rendererActions.getAnnotationMarks()?.some((mark)=>mark.attrs.id === annotationId) : false;
                if (annotationId && !annotationExists && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux')) {
                    setCurrentlySelectedThreadKey(annotationId, (0, $8i27m.CommentType).INLINE); // needed so that the view knows which thread to scroll to after rendering the threads
                    setCommentContainerToFocus(commentId); // we'll be using this to scroll to it using data-comment-id
                    showCommentsPanel({
                        openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                    });
                    (0, $6mKj3.expValEquals)('confluence_comment_expand_reply_editor', 'isEnabled', true) && onReplyToCommentReady();
                }
            }
            hasHandledCommentLink.current = true;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        queryParamData,
        isResolveDialogShown,
        rendererActions
    ]);
    // Only display the "comment not found" flag once
    (0, $42omo.useEffect)(()=>{
        if (isCommentNotFound) {
            const VIEWPAGE_COMMMENT_LINK_NOT_FOUND_FLAG_ID = `viewpage-comment-link-not-found-${commentId}`;
            flags.showWarningFlag({
                id: VIEWPAGE_COMMMENT_LINK_NOT_FOUND_FLAG_ID,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $61084f20d36cc3f6$export$a7357cdd1f0b0168.commentLinkNotFoundFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $61084f20d36cc3f6$export$a7357cdd1f0b0168.commentLinkNotFoundFlagDescription)
            });
        }
    }, [
        commentId,
        flags,
        isCommentNotFound
    ]);
    return null;
};
const $61084f20d36cc3f6$var$tryToFocusAndScrollActiveComment = ({ parentId: parentId, annotationId: annotationId, commentId: commentId })=>{
    const mark = document.querySelector(`[data-id="${annotationId}"]`);
    if (mark) {
        const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
        // If the already open container is showing the correct comment, don't send another click event to open it
        if (focusedMarkerRef?.id !== annotationId) {
            const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
            (0, $aHcFH.checkElementExpand)(mark, true);
            emitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                annotationIds: [
                    annotationId
                ],
                eventTarget: mark
            });
        }
        // Using common utility from comments-util
        // if the comment is a reply, don't scroll to it here, we'll handle the reply scrolling after the reply has rendered to avoid double scrolling
        if (!parentId && !(0, $9wGTI.fg)('confluence-fe-comments-deep-link-behavior')) {
            (0, $4u5NT.abortAll)('new_interaction', `focused-comment-scroll`);
            // note that this is for Renderer for now
            (0, $aHcFH.scrollToElementWithViewingRoom)({
                element: mark,
                useInstantScroll: true
            });
        }
        // Only proceed if we have a valid commentId
        if (commentId && (0, $9wGTI.fg)('confluence-fe-comments-deep-link-behavior')) {
            // Use new unified navigation when feature flag is enabled
            if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) {
                const success = (0, $9FoVw.handleDeepLinkNavigation)({
                    scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                    context: (0, $9FoVw.NavigationContext).RENDERER,
                    block: 'center',
                    markElement: mark,
                    commentId: commentId
                });
                if (!success) {
                    // Fallback to original behavior if unified navigation fails
                    (0, $4u5NT.abortAll)('new_interaction', `focused-comment-scroll`);
                    (0, $aHcFH.scrollToElementWithViewingRoom)({
                        element: mark,
                        useInstantScroll: true
                    });
                }
            } else {
                // Check if comment already exists in DOM
                const existingComment = document.querySelector(`[data-comment-id="${commentId}"]`);
                if (existingComment) {
                    const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
                    const allRepliesVisible = !showMoreButton;
                    if (allRepliesVisible) existingComment.scrollIntoView({
                        behavior: 'instant',
                        block: 'center'
                    });
                    else {
                        (0, $4u5NT.abortAll)('new_interaction', `focused-comment-scroll`);
                        (0, $aHcFH.scrollToElementWithViewingRoom)({
                            element: mark,
                            useInstantScroll: true
                        });
                    }
                } else // Watch for comment to be rendered using common utility
                (0, $aHcFH.watchForCommentRepliesAndScroll)({
                    targetCommentId: commentId,
                    onScrollReady: (commentElement)=>{
                        commentElement.scrollIntoView({
                            behavior: 'instant',
                            block: 'center'
                        });
                    },
                    onFallback: ()=>{
                        (0, $4u5NT.abortAll)('new_interaction', `focused-comment-scroll`);
                        (0, $aHcFH.scrollToElementWithViewingRoom)({
                            element: mark,
                            useInstantScroll: true
                        });
                    },
                    markElement: document.querySelector(`[data-id="${annotationId}"]`)
                });
            }
        }
    }
    return !!mark;
};
const $61084f20d36cc3f6$export$34418bee20f397f = (0, $7aRa9.withFlags)($61084f20d36cc3f6$export$3cf51438c4a7a1a);














const $f7fdc9c663d47c5a$export$2f2529470fc43ad6 = /*#__PURE__*/ (0, $42omo.memo)(({ actions: actions, pageId: pageId })=>{
    const { setRendererActions: setRendererActions } = (0, $8WQTF.useRendererActionsDispatch)();
    (0, $42omo.useEffect)(()=>{
        setRendererActions(actions, pageId);
    }, [
        actions,
        pageId,
        setRendererActions
    ]);
    return null;
});






var $804Ue = parcelRequire("804Ue");







var $7S9uM = parcelRequire("7S9uM");


var $gRrX4 = parcelRequire("gRrX4");





var $aMfLn = parcelRequire("aMfLn");














var $3BPrE = parcelRequire("3BPrE");


var $03oqz = parcelRequire("03oqz");

const $039e5ede5bcb8619$var$sendFailedPubsubEvent = ({ createAnalyticsEvent: createAnalyticsEvent, publishVersionNumber: publishVersionNumber, publishedDocumentVersion: publishedDocumentVersion })=>{
    if (createAnalyticsEvent && publishVersionNumber && publishedDocumentVersion) createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            source: 'rendererInlineCommentsPubSub',
            action: 'failed',
            actionSubject: 'createPubSubEvent',
            actionSubjectId: 'rendererInlineComments',
            attributes: {
                stepVersion: publishVersionNumber,
                documentVersion: publishedDocumentVersion
            }
        }
    }).fire();
};
const $039e5ede5bcb8619$var$isEventCommentThreadOpen = (markerRef)=>{
    if (!markerRef) return false;
    const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
    // Figure out if the reply's parent markerRef is open
    // HACK: Is there a way to do this without query selectors?
    return focusedMarkerRef && focusedMarkerRef.id === markerRef;
};
const $039e5ede5bcb8619$export$4197a8a52311d1d2 = ({ inlineCommentRequestBody: inlineCommentRequestBody, rendererActions: rendererActions, updateDocument: updateDocument, needsContentUpdate: needsContentUpdate, setContentNeedsUpdate: setContentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, createAnalyticsEvent: createAnalyticsEvent })=>{
    if (createAnalyticsEvent) createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            source: 'rendererInlineCommentsPubSub',
            action: 'received',
            actionSubject: 'createPubSubEvent',
            actionSubjectId: 'rendererInlineComments'
        }
    }).fire();
    const { markerRef: markerRef, step: step, publishVersionNumber: publishVersionNumber } = inlineCommentRequestBody;
    // If the users content is out of date or different, the steps from this pubsub event will be wrong
    // The new comment flag shown by VQR will be triggered to refetch the content
    if (step && publishVersionNumber === publishedDocumentVersion && !needsContentUpdate) {
        const { to: to, from: from, pos: pos, mark: { attrs: { annotationType: annotationType } } } = step;
        const position = pos !== undefined && pos !== null ? {
            to: pos,
            from: pos
        } : {
            to: to,
            from: from
        };
        const annotation = {
            annotationId: markerRef,
            annotationType: annotationType
        };
        const result = rendererActions?.applyAnnotation(position, annotation);
        if (result) updateDocument && updateDocument(result.doc);
    } else {
        if (!needsContentUpdate) setContentNeedsUpdate && setContentNeedsUpdate(true);
        // If we can't apply the step, send an event
        $039e5ede5bcb8619$var$sendFailedPubsubEvent({
            createAnalyticsEvent: createAnalyticsEvent,
            publishVersionNumber: publishVersionNumber,
            publishedDocumentVersion: publishedDocumentVersion
        });
    }
};
const $039e5ede5bcb8619$export$14eb0441cdcaaa35 = ({ inlineCommentRequestBody: inlineCommentRequestBody, rendererActions: rendererActions, updateDocument: updateDocument, eventEmitter: eventEmitter })=>{
    const { markerRef: markerRef } = inlineCommentRequestBody;
    if ($039e5ede5bcb8619$var$isEventCommentThreadOpen(markerRef)) eventEmitter?.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
    const deleteResult = rendererActions?.deleteAnnotation(markerRef, (0, $cUycv.AnnotationTypes).INLINE_COMMENT);
    if (deleteResult) updateDocument && updateDocument(deleteResult.doc);
};
const $039e5ede5bcb8619$var$refreshCommentThreadIfOpen = ({ contentId: contentId, inlineCommentRequestBody: inlineCommentRequestBody })=>{
    const { markerRef: markerRef } = inlineCommentRequestBody;
    if ($039e5ede5bcb8619$var$isEventCommentThreadOpen(markerRef) && contentId) // If so, update it's cache entry
    (0, $03oqz.refreshCommentThread)(contentId, markerRef);
// Otherwise do nothing
};
let $039e5ede5bcb8619$var$pagePublicationEventParams = {};
const $039e5ede5bcb8619$var$setPagePublicationEventParams = (params)=>{
    $039e5ede5bcb8619$var$pagePublicationEventParams = params;
};
const $039e5ede5bcb8619$var$onPagePublicationEvent = async (event, payload)=>{
    let confVersion;
    let trigger;
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
        confVersion = payload.pageUpdated.confVersion;
        trigger = payload.pageUpdated.trigger;
    } else {
        confVersion = payload.pageUpdatedRequestBody.confVersion;
        trigger = payload.pageUpdatedRequestBody.trigger;
    }
    const { setContentNeedsUpdate: setContentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, setPublishedDocumentVersion: setPublishedDocumentVersion } = $039e5ede5bcb8619$var$pagePublicationEventParams;
    // need to modify this for subscriptions since the event wont have avi/know content type this way
    // myabe the type in the page updated response will be what we want
    // if pageupdated trigger is publish
    if ((event === (0, $3BPrE.PagePubSubEvents).PagePublished || event === (0, $3BPrE.PagePubSubEvents).BlogPublished || event === (0, $3BPrE.PageSubscriptionEvents).PageUpdated && trigger === 'publish') && publishedDocumentVersion !== confVersion) {
        // TODO: Eventually we want to read the values passed to us to see if this is positional breaking
        setContentNeedsUpdate && setContentNeedsUpdate(true);
        if ((0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) setPublishedDocumentVersion && setPublishedDocumentVersion(confVersion);
    }
};
let $039e5ede5bcb8619$var$commentPublicationEventParams = {};
const $039e5ede5bcb8619$export$11d6bf62aa2fcbf9 = (params)=>{
    $039e5ede5bcb8619$var$commentPublicationEventParams = params;
};
const $039e5ede5bcb8619$export$8579923c4bc2600 = async (event, payload)=>{
    const eventEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
    const { accountId: accountId } = payload;
    let inlineCommentRequestBody;
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) inlineCommentRequestBody = payload?.[event];
    else inlineCommentRequestBody = payload.inlineCommentRequestBody;
    const { inlineCommentType: inlineCommentType, markerRef: markerRef, commentId: commentId } = inlineCommentRequestBody || {};
    const { contentId: contentId, currentUserId: currentUserId, rendererActions: rendererActions, updateDocument: updateDocument, updateUnresolvedInlineComment: updateUnresolvedInlineComment, needsContentUpdate: needsContentUpdate, setContentNeedsUpdate: setContentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, createAnalyticsEvent: createAnalyticsEvent, addNewCommentThreads: addNewCommentThreads, addReplyToCommentThread: addReplyToCommentThread, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, updateCommentBody: updateCommentBody, storedCommentData: storedCommentData, setStoredCommentData: setStoredCommentData, updateUnreadCommentIDSet: updateUnreadCommentIDSet, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, setActiveHighlight: setActiveHighlight, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = $039e5ede5bcb8619$var$commentPublicationEventParams;
    // Don't do anything when the current user performs an action
    if (accountId === currentUserId) return;
    const lastestStoredCommentData = storedCommentData?.();
    const isReply = inlineCommentType === 'REPLY';
    switch(event){
        case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentUnresolved:
        case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentUnresolved:
            if (event && (0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                    if (commentId && contentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                    await (0, $lb2Lp.fetchCommentById)({
                        commentId: commentId,
                        contentId: contentId,
                        fetchPolicy: 'network-only'
                    });
                } else // We load resolved + active separately, so unless the user has visited the resolved tab, the comment thread won't be in the state
                // Hance the await here - as part of this function we update state
                await (0, $03oqz.handleAddNewCommentThread)({
                    contentId: contentId,
                    markerRef: markerRef,
                    addNewCommentThreads: addNewCommentThreads
                });
                // Remove from commentThreadsRemovedByOtherUsers when reopened
                if (markerRef && reopenParentComment && (0, $9wGTI.fg)('confluence_comments_reply_inline_reliability')) reopenParentComment({
                    threadKey: markerRef,
                    commentType: (0, $8i27m.CommentType).INLINE
                });
            }
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
                [markerRef]: {
                    id: markerRef,
                    annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
                    state: (0, $cUycv.AnnotationMarkStates).ACTIVE
                }
            });
            break;
        case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentResolved:
        case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentResolved:
            // If the thread is open, close it and clear highlight
            if ($039e5ede5bcb8619$var$isEventCommentThreadOpen(markerRef)) {
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                if ((0, $6mKj3.expValEquals)('confluence_comment_resolve_kbs_fix', 'isEnabled', true)) setActiveHighlight?.(null);
            }
            // Remove the resolved comment from the navigation list
            if (setOrderedActiveAnnotationIdList && orderedActiveAnnotationIdList && (0, $6mKj3.expValEquals)('confluence_comment_resolve_kbs_fix', 'isEnabled', true)) setOrderedActiveAnnotationIdList(orderedActiveAnnotationIdList.map((status)=>status.threadKey).filter((id)=>id !== markerRef));
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
                [markerRef]: {
                    id: markerRef,
                    annotationType: (0, $cUycv.AnnotationTypes).INLINE_COMMENT,
                    state: (0, $cUycv.AnnotationMarkStates).RESOLVED
                }
            });
            if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                    if (commentId && contentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                    (0, $lb2Lp.fetchCommentById)({
                        commentId: commentId,
                        contentId: contentId,
                        fetchPolicy: 'network-only'
                    });
                }
                const { inlineResolveProperties: inlineResolveProperties, inlineText: inlineText } = inlineCommentRequestBody;
                updateRemovedCommentIdsMap && inlineResolveProperties && (inlineText || (0, $9wGTI.fg)('confluence_comments_reply_inline_reliability')) && updateRemovedCommentIdsMap({
                    threadKey: markerRef,
                    commentId: commentId,
                    commentActionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
                    isReply: isReply,
                    commentType: (0, $8i27m.CommentType).INLINE,
                    resolvedProperties: {
                        inlineResolveProperties: inlineResolveProperties,
                        inlineText: inlineText
                    }
                });
                if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) {
                    const { replies: replies = [] } = inlineCommentRequestBody;
                    if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                        commentId,
                        ...replies
                    ]), 'remove');
                }
            }
            break;
        case (0, $3BPrE.InlineCommentSubscriptionEvents).RendererInlineCommentCreated:
        case (0, $3BPrE.InlineCommentPubSubEvents).RendererInlineCommentCreated:
            if (inlineCommentType === 'TOP_LEVEL') {
                // New comments data manger needs to call this AFTER update. See note below
                if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) $039e5ede5bcb8619$export$4197a8a52311d1d2({
                    inlineCommentRequestBody: inlineCommentRequestBody,
                    rendererActions: rendererActions,
                    updateDocument: updateDocument,
                    needsContentUpdate: needsContentUpdate,
                    setContentNeedsUpdate: setContentNeedsUpdate,
                    publishedDocumentVersion: publishedDocumentVersion,
                    createAnalyticsEvent: createAnalyticsEvent
                });
                if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (addCommentInCache && commentId && contentId) {
                            const comment = await (0, $lb2Lp.fetchCommentById)({
                                commentId: commentId,
                                contentId: contentId,
                                fetchPolicy: 'network-only'
                            });
                            if (comment) addCommentInCache({
                                newComment: comment
                            });
                            // This needs to happen AFTER the cache update. applyStepAndAddCommentToDoc triggers the doc to re-render, which triggers getRendererAnnotationStates
                            // getRendererAnnotationStates pulls data from the cache to determine which annotations to show
                            // In the legacy version this wasn't a problem, since it does a full network call
                            $039e5ede5bcb8619$export$4197a8a52311d1d2({
                                inlineCommentRequestBody: inlineCommentRequestBody,
                                rendererActions: rendererActions,
                                updateDocument: updateDocument,
                                needsContentUpdate: needsContentUpdate,
                                setContentNeedsUpdate: setContentNeedsUpdate,
                                publishedDocumentVersion: publishedDocumentVersion,
                                createAnalyticsEvent: createAnalyticsEvent
                            });
                        }
                    } else (0, $03oqz.handleAddNewCommentThread)({
                        contentId: contentId,
                        markerRef: markerRef,
                        addNewCommentThreads: addNewCommentThreads
                    });
                    if (updateUnreadCommentIDSet && (0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'add');
                }
            } else if (isReply) {
                if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (addCommentInCache && commentId && contentId) {
                            const comment = await (0, $lb2Lp.fetchCommentById)({
                                commentId: commentId,
                                contentId: contentId,
                                fetchPolicy: 'network-only'
                            });
                            if (comment) addCommentInCache({
                                newComment: comment
                            });
                        }
                    } else (0, $03oqz.handleAddedReplyInCommentThread)({
                        contentId: contentId,
                        markerRef: markerRef,
                        commentId: commentId,
                        addReplyToCommentThread: addReplyToCommentThread,
                        commentType: (0, $8i27m.CommentType).INLINE,
                        storedCommentData: lastestStoredCommentData,
                        setStoredCommentData: setStoredCommentData
                    });
                    if (updateUnreadCommentIDSet && (0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'add');
                } else $039e5ede5bcb8619$var$refreshCommentThreadIfOpen({
                    contentId: contentId,
                    inlineCommentRequestBody: inlineCommentRequestBody
                });
            }
            break;
        // just for replies
        case (0, $3BPrE.InlineCommentSubscriptionEvents).EditorInlineCommentCreated:
        case (0, $3BPrE.InlineCommentPubSubEvents).EditorInlineCommentCreated:
            if (isReply) {
                if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (addCommentInCache && commentId && contentId) {
                            const comment = await (0, $lb2Lp.fetchCommentById)({
                                commentId: commentId,
                                contentId: contentId,
                                fetchPolicy: 'network-only'
                            });
                            if (comment) addCommentInCache({
                                newComment: comment
                            });
                        }
                    } else (0, $03oqz.handleAddedReplyInCommentThread)({
                        contentId: contentId,
                        markerRef: markerRef,
                        commentId: commentId,
                        addReplyToCommentThread: addReplyToCommentThread,
                        commentType: (0, $8i27m.CommentType).INLINE,
                        storedCommentData: lastestStoredCommentData,
                        setStoredCommentData: setStoredCommentData
                    });
                    // Check if the annotation exists in the renderer DOM before updating unread comments
                    const annotationElement = document.getElementById(markerRef);
                    if (annotationElement && updateUnreadCommentIDSet && (0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'add');
                } else $039e5ede5bcb8619$var$refreshCommentThreadIfOpen({
                    contentId: contentId,
                    inlineCommentRequestBody: inlineCommentRequestBody
                });
            }
            break;
        case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentDeleted:
        case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentDeleted:
            // Always handle annotation logic
            if (inlineCommentType === 'TOP_LEVEL') $039e5ede5bcb8619$export$14eb0441cdcaaa35({
                inlineCommentRequestBody: inlineCommentRequestBody,
                rendererActions: rendererActions,
                updateDocument: updateDocument,
                eventEmitter: eventEmitter
            });
            else if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) $039e5ede5bcb8619$var$refreshCommentThreadIfOpen({
                contentId: contentId,
                inlineCommentRequestBody: inlineCommentRequestBody
            });
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                if (deleteCommentInCache && commentId) deleteCommentInCache({
                    commentId: commentId
                });
            }
            // both a parent comment and reply can be deleted
            if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                updateRemovedCommentIdsMap && updateRemovedCommentIdsMap({
                    threadKey: markerRef,
                    commentId: commentId,
                    commentActionType: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                    isReply: isReply,
                    commentType: (0, $8i27m.CommentType).INLINE
                });
                if (updateUnreadCommentIDSet && (0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) updateUnreadCommentIDSet(new Set([
                    commentId
                ]), 'remove');
            }
            break;
        case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentReattached:
        case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentReattached:
            $039e5ede5bcb8619$export$4197a8a52311d1d2({
                inlineCommentRequestBody: inlineCommentRequestBody,
                rendererActions: rendererActions,
                updateDocument: updateDocument,
                needsContentUpdate: needsContentUpdate,
                setContentNeedsUpdate: setContentNeedsUpdate,
                publishedDocumentVersion: publishedDocumentVersion,
                createAnalyticsEvent: createAnalyticsEvent
            });
            break;
        case (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentUpdated:
        case (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentUpdated:
            // If the initial comment thread is open, refresh it
            if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                    if (commentId && contentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                    (0, $lb2Lp.fetchCommentById)({
                        commentId: commentId,
                        contentId: contentId,
                        fetchPolicy: 'network-only'
                    });
                } else updateCommentBody && (0, $03oqz.handleEditedComment)({
                    contentId: contentId,
                    markerRef: markerRef,
                    commentId: commentId,
                    updateCommentBody: updateCommentBody
                });
            } else $039e5ede5bcb8619$var$refreshCommentThreadIfOpen({
                contentId: contentId,
                inlineCommentRequestBody: inlineCommentRequestBody
            });
            break;
        default:
            return;
    }
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
        if (inlineCommentType !== 'REPLY' && !needsContentUpdate && event !== (0, $3BPrE.InlineCommentSubscriptionEvents).RendererInlineCommentCreated && event !== (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentReattached && event !== (0, $3BPrE.InlineCommentSubscriptionEvents).InlineCommentDeleted) {
            if (rendererActions && contentId && updateUnresolvedInlineComment) (0, $aMfLn.updateRendererAnnotations)({
                rendererActions: rendererActions,
                contentId: contentId,
                updateUnresolvedInlineComment: updateUnresolvedInlineComment
            });
        }
    } else {
        // Always update if we've handled the event
        if (inlineCommentType !== 'REPLY' && !needsContentUpdate && event !== (0, $3BPrE.InlineCommentPubSubEvents).RendererInlineCommentCreated && event !== (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentReattached && event !== (0, $3BPrE.InlineCommentPubSubEvents).InlineCommentDeleted) {
            if (rendererActions && contentId && updateUnresolvedInlineComment) (0, $aMfLn.updateRendererAnnotations)({
                rendererActions: rendererActions,
                contentId: contentId,
                updateUnresolvedInlineComment: updateUnresolvedInlineComment
            });
        }
    }
};
function $039e5ede5bcb8619$export$9ac99a17b366f8ef({ contentId: contentId, currentUserId: currentUserId, contentType: contentType, rendererActions: rendererActions, updateDocument: updateDocument, updateUnresolvedInlineComment: updateUnresolvedInlineComment, setContentNeedsUpdate: setContentNeedsUpdate, needsContentUpdate: needsContentUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion, publishedDocumentVersion: publishedDocumentVersion, createAnalyticsEvent: createAnalyticsEvent, addReplyToCommentThread: addReplyToCommentThread, addNewCommentThreads: addNewCommentThreads, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, updateCommentBody: updateCommentBody, storedCommentData: storedCommentData, setStoredCommentData: setStoredCommentData, addSubscriber: addSubscriber, setContentId: setContentId, setContentType: setContentType, updateUnreadCommentIDSet: updateUnreadCommentIDSet, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, setActiveHighlight: setActiveHighlight, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList }) {
    const pubSubResourceType = contentType || 'page';
    $039e5ede5bcb8619$export$11d6bf62aa2fcbf9({
        contentId: contentId,
        currentUserId: currentUserId,
        rendererActions: rendererActions,
        updateDocument: updateDocument,
        updateUnresolvedInlineComment: updateUnresolvedInlineComment,
        needsContentUpdate: needsContentUpdate,
        setContentNeedsUpdate: setContentNeedsUpdate,
        publishedDocumentVersion: publishedDocumentVersion,
        createAnalyticsEvent: createAnalyticsEvent,
        addReplyToCommentThread: addReplyToCommentThread,
        addNewCommentThreads: addNewCommentThreads,
        updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
        reopenParentComment: reopenParentComment,
        updateCommentBody: updateCommentBody,
        storedCommentData: storedCommentData,
        setStoredCommentData: setStoredCommentData,
        updateUnreadCommentIDSet: updateUnreadCommentIDSet,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache,
        setActiveHighlight: setActiveHighlight,
        setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList,
        orderedActiveAnnotationIdList: orderedActiveAnnotationIdList
    });
    $039e5ede5bcb8619$var$setPagePublicationEventParams({
        currentUserId: currentUserId,
        setContentNeedsUpdate: setContentNeedsUpdate,
        publishedDocumentVersion: publishedDocumentVersion,
        setPublishedDocumentVersion: setPublishedDocumentVersion
    });
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
        if (!addSubscriber || !setContentId || !setContentType) return;
        const subscriptions = [];
        setContentType(pubSubResourceType);
        setContentId(contentId);
        const subscribers = [
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentResolved',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentResolved'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentUnresolved',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentUnresolved'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubRendererInlineCommentCreated',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'rendererInlineCommentCreated'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubEditorInlineCommentCreated',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'editorInlineCommentCreated'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentDeleted',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentDeleted'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentReattached',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentReattached'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubInlineCommentUpdated',
                onSubscriptionData: $039e5ede5bcb8619$export$8579923c4bc2600,
                delta: 'inlineCommentUpdated'
            },
            {
                subscriberId: 'renderInlineCommentsPubSubPageUpdated',
                onSubscriptionData: $039e5ede5bcb8619$var$onPagePublicationEvent,
                delta: 'pageUpdated'
            }
        ];
        for (const subscriber of subscribers)subscriptions.push({
            subscriberId: addSubscriber(subscriber),
            delta: subscriber.delta
        });
        return subscriptions;
    } else (0, $gRrX4.getPubSubClient)().then((client)=>{
        client.joinChannel(pubSubResourceType, contentId).finally(()=>{
            client.subscribe((0, $7S9uM.eventToAvi)('resolved:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('unresolved:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('created:renderer_inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('created:editor_inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('deleted:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('reattach:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('updated:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
            client.subscribe((0, $7S9uM.eventToAvi)('publish:page'), $039e5ede5bcb8619$var$onPagePublicationEvent);
            client.subscribe((0, $7S9uM.eventToAvi)('publish:blogpost'), $039e5ede5bcb8619$var$onPagePublicationEvent);
        }).catch((error)=>{
            throw new Error(`PubSub Web Client joinChannel ${JSON.stringify(error)}`);
        });
    });
}
function $039e5ede5bcb8619$export$d3539dc2c41bd511({ contentId: contentId, contentType: contentType, subscriptions: subscriptions, removeSubscriber: removeSubscriber }) {
    const pubSubResourceType = contentType || 'page';
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) for (const subscriber of subscriptions)removeSubscriber?.(subscriber);
    else (0, $gRrX4.getPubSubClient)().then((client)=>{
        client.leaveChannel(pubSubResourceType, contentId);
        client.unsubscribe((0, $7S9uM.eventToAvi)('resolved:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('unresolved:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('created:renderer_inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('created:editor_inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('deleted:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('reattach:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('updated:inline_comment'), $039e5ede5bcb8619$export$8579923c4bc2600);
        client.unsubscribe((0, $7S9uM.eventToAvi)('publish:page'), $039e5ede5bcb8619$var$onPagePublicationEvent);
        client.unsubscribe((0, $7S9uM.eventToAvi)('publish:blogpost'), $039e5ede5bcb8619$var$onPagePublicationEvent);
    });
}



var $fgQGl = parcelRequire("fgQGl");


var $5pQ1Y = parcelRequire("5pQ1Y");


var $k8e76 = parcelRequire("k8e76");


var $9jl6v = parcelRequire("9jl6v");


var $fHAwL = parcelRequire("fHAwL");





var $7d2Nc = parcelRequire("7d2Nc");


var $a3q17 = parcelRequire("a3q17");





var $WheoQ = parcelRequire("WheoQ");


var $NYiei = parcelRequire("NYiei");

const $24269a0cd7d91594$var$InlineCommentsPubSubHandler = ({ contentId: contentId, contentType: contentType, updateDocument: updateDocument, rendererActions: rendererActions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setDocumentUpdated: setDocumentUpdated } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const { setRefetchContent: setRefetchContent } = (0, $5pQ1Y.useContentRefetchDispatch)();
    const { documentNeedsUpdate: documentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { addSubscriber: addSubscriber, removeSubscriber: removeSubscriber, setContentType: setContentType, setContentId: setContentId } = (0, $6UYek.useSubscriptionsDispatchContext)() || {};
    const subscriptions = (0, $42omo.useRef)([]);
    const { setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { updateUnresolvedInlineComment: updateUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)();
    const { setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, addReplyToCommentThread: addReplyToCommentThread, addNewCommentThreads: addNewCommentThreads, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, updateCommentBody: updateCommentBody } = (0, $8i27m.useCommentsDataActions)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { updateUnreadCommentsOnFirstRender: updateUnreadCommentsOnFirstRender, updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    const { storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { setStoredCommentData: setStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    const { setActiveHighlight: setActiveHighlight } = (0, $9jl6v.useInlineCommentsDispatchContext)() || {};
    const latestStoredCommentRef = (0, $42omo.useRef)(storedCommentData);
    const { deleteCommentInCache: deleteCommentInCache, addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const updateUnresolvedInlineCommentFn = (0, $WheoQ.useUpdateAnnotations)([
        updateUnresolvedInlineComment,
        setOrderedActiveAnnotationIdList
    ]);
    (0, $42omo.useEffect)(()=>{
        latestStoredCommentRef.current = storedCommentData;
    }, [
        storedCommentData
    ]);
    const subscribeToPubSub = (0, $42omo.useCallback)(()=>{
        if (subscriptions.current.length > 0 && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return subscriptions.current;
        subscriptions.current = (0, $039e5ede5bcb8619$export$9ac99a17b366f8ef)({
            contentId: contentId,
            currentUserId: userId,
            contentType: contentType,
            rendererActions: rendererActions,
            updateDocument: updateDocument,
            updateUnresolvedInlineComment: (0, $9wGTI.fg)('confluence-frontend-comments-panel') ? updateUnresolvedInlineCommentFn : updateUnresolvedInlineComment,
            setContentNeedsUpdate: setDocumentNeedsUpdate,
            needsContentUpdate: Boolean(documentNeedsUpdate),
            setPublishedDocumentVersion: setPublishedDocumentVersion,
            publishedDocumentVersion: publishedDocumentVersion,
            createAnalyticsEvent: createAnalyticsEvent,
            addNewCommentThreads: addNewCommentThreads,
            addReplyToCommentThread: addReplyToCommentThread,
            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
            reopenParentComment: reopenParentComment,
            updateCommentBody: updateCommentBody,
            storedCommentData: ()=>latestStoredCommentRef.current,
            setStoredCommentData: setStoredCommentData,
            addSubscriber: addSubscriber,
            setContentType: setContentType,
            setContentId: setContentId,
            updateUnreadCommentIDSet: updateUnreadCommentIDSet,
            addCommentInCache: addCommentInCache,
            deleteCommentInCache: deleteCommentInCache,
            setActiveHighlight: setActiveHighlight,
            setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList,
            orderedActiveAnnotationIdList: orderedActiveAnnotationIdList
        }) || [];
        return subscriptions.current;
    // We only need to respond to values that CAN change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        userId,
        contentType,
        rendererActions,
        documentNeedsUpdate,
        publishedDocumentVersion,
        storedCommentData,
        setStoredCommentData,
        addSubscriber,
        setContentType,
        setContentId,
        addCommentInCache,
        deleteCommentInCache
    ]);
    const unsubscribeFromPubSub = (0, $42omo.useCallback)(()=>{
        if (subscriptions.current.length === 0 && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
        (0, $039e5ede5bcb8619$export$d3539dc2c41bd511)({
            contentId: contentId,
            contentType: contentType,
            removeSubscriber: removeSubscriber,
            subscriptions: subscriptions.current
        });
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) subscriptions.current = [];
    }, [
        contentId,
        contentType,
        removeSubscriber
    ]);
    const handleFetchContentVersionEvent = (0, $42omo.useCallback)(()=>{
        setDocumentNeedsUpdate(true);
    }, [
        setDocumentNeedsUpdate
    ]);
    const handleEventFetchSuccess = (0, $42omo.useCallback)((res)=>{
        // TODO: Parse the events returned for 'resolved', 'unresolved', and 'delete' when they are added
        //       for now we just reload the content when the user comes back
        // For now all we have is create events, which means we will miss things, but only update if a new ones were created
        if (res.commentEvents.length > 0) {
            setDocumentUpdated(true);
            setRefetchContent(true);
            if (!(0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) updateUnreadCommentsOnFirstRender(true);
        }
    }, [
        setRefetchContent,
        setDocumentUpdated,
        updateUnreadCommentsOnFirstRender
    ]);
    if (!userId) return null;
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $804Ue.MissedPubSubCommentEventsHandler), {
        contentId: contentId,
        eventType: (0, $804Ue.CommentEventType).INLINE,
        subscribeToPubSubEvents: subscribeToPubSub,
        unsubscribeFromPubSubEvents: unsubscribeFromPubSub,
        onEventFetchSuccess: handleEventFetchSuccess,
        onFetchContentVersionEvent: handleFetchContentVersionEvent,
        inactiveInterval: 0,
        returnInterval: 0
    });
};
const $24269a0cd7d91594$var$WithAnnotationsWrapperComponent = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(29);
    const { flags: flags, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, updateDocument: updateDocument, isNestedRender: t1, children: children, lastModifiedDate: lastModifiedDate, isArchived: t2 } = t0;
    const isNestedRender = t1 === undefined ? false : t1;
    const isArchived = t2 === undefined ? false : t2;
    const pageContainsBodiedMacrosRef = (0, $42omo.useRef)(false);
    const { setDocumentUpdated: setDocumentUpdated, setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const { refetchContent: refetchContent } = (0, $5pQ1Y.useContentRefetch)();
    const { setRefetchContent: setRefetchContent } = (0, $5pQ1Y.useContentRefetchDispatch)();
    const [t3] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, contentType: contentType } = t3;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { selectionProps: selectionProps, viewProps: viewProps, hoverProps: hoverProps, isOffline: isOffline } = (0, $cZa7r.useAnnotations)();
    const { updateUnreadCommentsOnFirstRender: updateUnreadCommentsOnFirstRender } = (0, $fHAwL.useUnreadCommentsActions)();
    const handleAnnotationsLoaded = $24269a0cd7d91594$var$_temp;
    let t4;
    if ($[0] !== contentId || $[1] !== contentType || $[2] !== createAnalyticsEvent || $[3] !== flags || $[4] !== setDocumentNeedsUpdate || $[5] !== setDocumentUpdated || $[6] !== setPublishedDocumentVersion || $[7] !== setRefetchContent || $[8] !== updateUnreadCommentsOnFirstRender) {
        t4 = (versionNumber)=>{
            setRefetchContent(false);
            setDocumentUpdated(true);
            setDocumentNeedsUpdate(false);
            if (!(0, $9wGTI.fg)("confluence_frontend_unread_comments_fixes")) updateUnreadCommentsOnFirstRender(true);
            flags.hideAllFlags();
            if (versionNumber) setPublishedDocumentVersion(versionNumber);
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "refetched",
                    actionSubject: "content",
                    objectId: contentId,
                    contentType: contentType,
                    source: "viewPageScreen"
                }
            }).fire();
        };
        $[0] = contentId;
        $[1] = contentType;
        $[2] = createAnalyticsEvent;
        $[3] = flags;
        $[4] = setDocumentNeedsUpdate;
        $[5] = setDocumentUpdated;
        $[6] = setPublishedDocumentVersion;
        $[7] = setRefetchContent;
        $[8] = updateUnreadCommentsOnFirstRender;
        $[9] = t4;
    } else t4 = $[9];
    const handleOnRefetchComplete = t4;
    let t5;
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            const bodiedMacroElem = document.querySelector(".ak-renderer-extension");
            pageContainsBodiedMacrosRef.current = Boolean(bodiedMacroElem);
        };
        t6 = [];
        $[10] = t5;
        $[11] = t6;
    } else {
        t5 = $[10];
        t6 = $[11];
    }
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    if ($[12] !== adfDocument || $[13] !== annotationProvider || $[14] !== children || $[15] !== contentId || $[16] !== contentType || $[17] !== handleOnRefetchComplete || $[18] !== hoverProps || $[19] !== isArchived || $[20] !== isNestedRender || $[21] !== isOffline || $[22] !== lastModifiedDate || $[23] !== refetchContent || $[24] !== rendererRef || $[25] !== selectionProps || $[26] !== updateDocument || $[27] !== viewProps) {
        t7 = annotationProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1befae30f885f9b9$export$f9718e664221d42a), {
            render: (actions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
                    key: contentId,
                    metric: (0, $a3q17.FABRIC_COMMENTS_HIGHLIGHTS_METRIC)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d7o2V.AnnotationsWrapper), {
                    rendererRef: rendererRef,
                    adfDocument: adfDocument,
                    annotationProvider: annotationProvider,
                    isNestedRender: isNestedRender,
                    onLoadComplete: handleAnnotationsLoaded
                }, !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0779e224f4e996ea$export$6f846e47e87c2a09), null), selectionProps && !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb59c4e491ffb95c$export$cf6655f87eaeee23), {
                    ...selectionProps,
                    isOffline: isOffline,
                    contentType: contentType,
                    lastModifiedDate: lastModifiedDate
                }), hoverProps && !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dd9a461270565732$export$e394de0b31ec5273), {
                    ...hoverProps,
                    isOffline: isOffline
                }), viewProps && !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $286e4a58224268a3$export$f845437bf1d007fd), {
                    ...viewProps,
                    isOffline: isOffline,
                    pageContainsBodiedMacros: pageContainsBodiedMacrosRef.current
                }), children), !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $61084f20d36cc3f6$export$34418bee20f397f), {
                    isArchived: isArchived,
                    rendererRef: rendererRef
                }), (0, $9wGTI.fg)("confluence_frontend_unread_comments_fixes") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7fdc9c663d47c5a$export$2f2529470fc43ad6), {
                    actions: actions,
                    pageId: contentId
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7fdc9c663d47c5a$export$2f2529470fc43ad6), {
                    actions: actions
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($24269a0cd7d91594$var$InlineCommentsPubSubHandler, {
                    contentId: contentId,
                    contentType: contentType,
                    updateDocument: updateDocument,
                    rendererActions: actions
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fgQGl.ContentRefetchHandler), {
                    contentId: contentId,
                    shouldRefetch: refetchContent,
                    refetchImmediately: true,
                    onRefetchComplete: handleOnRefetchComplete
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iVane.InlineCommentLinkHandler), null))
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children));
        $[12] = adfDocument;
        $[13] = annotationProvider;
        $[14] = children;
        $[15] = contentId;
        $[16] = contentType;
        $[17] = handleOnRefetchComplete;
        $[18] = hoverProps;
        $[19] = isArchived;
        $[20] = isNestedRender;
        $[21] = isOffline;
        $[22] = lastModifiedDate;
        $[23] = refetchContent;
        $[24] = rendererRef;
        $[25] = selectionProps;
        $[26] = updateDocument;
        $[27] = viewProps;
        $[28] = t7;
    } else t7 = $[28];
    return t7;
} : ({ flags: flags, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, updateDocument: updateDocument, isNestedRender: isNestedRender = false, children: children, lastModifiedDate: lastModifiedDate, isArchived: isArchived = false })=>{
    const pageContainsBodiedMacrosRef = (0, $42omo.useRef)(false);
    const { setDocumentUpdated: setDocumentUpdated, setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const { refetchContent: refetchContent } = (0, $5pQ1Y.useContentRefetch)();
    const { setRefetchContent: setRefetchContent } = (0, $5pQ1Y.useContentRefetchDispatch)();
    const [{ contentId: contentId, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { selectionProps: selectionProps, viewProps: viewProps, hoverProps: hoverProps, isOffline: isOffline } = (0, $cZa7r.useAnnotations)();
    const { updateUnreadCommentsOnFirstRender: updateUnreadCommentsOnFirstRender } = (0, $fHAwL.useUnreadCommentsActions)();
    const handleAnnotationsLoaded = (0, $42omo.useCallback)(({ numberOfUnresolvedInlineComments: numberOfUnresolvedInlineComments })=>{
        const options = {
            customData: {
                isFabricPage: true,
                numberOfUnresolvedInlineComments: numberOfUnresolvedInlineComments
            }
        };
        (0, $a3q17.FABRIC_COMMENTS_HIGHLIGHTS_METRIC).stop(options);
    }, []);
    const handleOnRefetchComplete = (0, $42omo.useCallback)((versionNumber)=>{
        setRefetchContent(false);
        setDocumentUpdated(true);
        setDocumentNeedsUpdate(false);
        if (!(0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) updateUnreadCommentsOnFirstRender(true);
        flags.hideAllFlags();
        if (versionNumber) setPublishedDocumentVersion(versionNumber);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'refetched',
                actionSubject: 'content',
                objectId: contentId,
                contentType: contentType,
                source: 'viewPageScreen'
            }
        }).fire();
    }, [
        setRefetchContent,
        setDocumentUpdated,
        createAnalyticsEvent,
        contentId,
        contentType,
        setDocumentNeedsUpdate,
        flags,
        setPublishedDocumentVersion,
        updateUnreadCommentsOnFirstRender
    ]);
    // We need to check that there are page properties macros or excerpt macros on the page
    // so we can hide the delete option which causes weird issues in the document
    (0, $42omo.useEffect)(()=>{
        const bodiedMacroElem = document.querySelector('.ak-renderer-extension');
        pageContainsBodiedMacrosRef.current = Boolean(bodiedMacroElem);
    }, []);
    return annotationProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1befae30f885f9b9$export$f9718e664221d42a), {
        render: (actions)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
                key: contentId,
                metric: (0, $a3q17.FABRIC_COMMENTS_HIGHLIGHTS_METRIC)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d7o2V.AnnotationsWrapper), {
                rendererRef: rendererRef,
                adfDocument: adfDocument,
                annotationProvider: annotationProvider,
                isNestedRender: isNestedRender,
                onLoadComplete: handleAnnotationsLoaded
            }, !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0779e224f4e996ea$export$6f846e47e87c2a09), null), selectionProps && !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb59c4e491ffb95c$export$cf6655f87eaeee23), {
                ...selectionProps,
                isOffline: isOffline,
                contentType: contentType,
                lastModifiedDate: lastModifiedDate
            }), hoverProps && !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dd9a461270565732$export$e394de0b31ec5273), {
                ...hoverProps,
                isOffline: isOffline
            }), viewProps && !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $286e4a58224268a3$export$f845437bf1d007fd), {
                ...viewProps,
                isOffline: isOffline,
                pageContainsBodiedMacros: pageContainsBodiedMacrosRef.current
            }), children), !isNestedRender && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $61084f20d36cc3f6$export$34418bee20f397f), {
                isArchived: isArchived,
                rendererRef: rendererRef
            }), (0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7fdc9c663d47c5a$export$2f2529470fc43ad6), {
                actions: actions,
                pageId: contentId
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7fdc9c663d47c5a$export$2f2529470fc43ad6), {
                actions: actions
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($24269a0cd7d91594$var$InlineCommentsPubSubHandler, {
                contentId: contentId,
                contentType: contentType,
                updateDocument: updateDocument,
                rendererActions: actions
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fgQGl.ContentRefetchHandler), {
                contentId: contentId,
                shouldRefetch: refetchContent,
                refetchImmediately: true,
                onRefetchComplete: handleOnRefetchComplete
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iVane.InlineCommentLinkHandler), null));
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lspPP.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children));
};
const $24269a0cd7d91594$export$548dda15276d1592 = (0, $7aRa9.withFlags)($24269a0cd7d91594$var$WithAnnotationsWrapperComponent);
function $24269a0cd7d91594$var$_temp(t0) {
    const { numberOfUnresolvedInlineComments: numberOfUnresolvedInlineComments } = t0;
    const options = {
        customData: {
            isFabricPage: true,
            numberOfUnresolvedInlineComments: numberOfUnresolvedInlineComments
        }
    };
    (0, $a3q17.FABRIC_COMMENTS_HIGHLIGHTS_METRIC).stop(options);
}
module.exports["WithAnnotationsWrapper"] = $24269a0cd7d91594$export$548dda15276d1592;

});


//# sourceMappingURL=PageContentRendererFabric.492cf8d5.js.map
